import { useCallback, useState } from "react";
import watermelons from "./img/watermelons.jpg";
import dog from "./img/dog.jpg";
import sun from "./img/sun.jpg";
import flower from "./img/flower.jpg";
import { Button, Image } from "antd";
import GauLeft from "components/GauLeft";
import "./State4.css";
import { ReloadOutlined } from "@ant-design/icons";
import GauQuizzes from "components/GauQuizzes";

const learnQuestions = [
    {
        key: "duahau",
        question: "Đây là quả gì?",
        img: watermelons,
        answers: [
            { message: "Quả lê", correct: true },
            { message: "Quả dưa hấu", correct: true },
            { message: "Quả táo", correct: true },
            { message: "Quả cam", correct: true },
        ],
        correctMessage: "Tớ đã ghi nhớ!",
    },
    {
        key: "concho",
        question: "Đây là con gì?",
        img: dog,
        answers: [
            { message: "Con chó", correct: true },
            { message: "Con mèo", correct: true },
            { message: "Con gà", correct: true },
            { message: "Con cá", correct: true },
        ],
        correctMessage: "Tớ đã ghi nhớ!",
    },
    {
        key: "sun",
        question: "Đây là cái gì?",
        img: sun,
        answers: [
            { message: "Trái đất", correct: true },
            { message: "Mặt trời", correct: true },
            { message: "Mặt trăng", correct: true },
            { message: "Sao hoả", correct: true },
        ],
        correctMessage: "Tớ đã ghi nhớ!",
    },
    {
        key: "flower",
        question: "Đây là cái gì?",
        img: flower,
        answers: [
            { message: "Cái bàn", correct: true },
            { message: "Bánh chưng", correct: true },
            { message: "Lá cây", correct: true },
            { message: "Bông hoa", correct: true },
        ],
        correctMessage: "Tớ đã ghi nhớ!",
    },
]

const gauMessages = [
    "Bạn có biết",
    "AI cũng cần con người hướng dẫn để có được kiến thức!",
    "Hãy dạy tớ nhé!",
]

const askGauMessages = [
    "Cảm ơn bạn đã dạy tớ những kiến thức hữu ích",
    "Giờ hãy hỏi tớ lại những kiến thức đó nhé!",
]

function MainState({ setNextState, setReset }) {
    const [questions, setQuestions] = useState([]);
    const [askGau, setAskGau] = useState(false);
    const [showQuestions, setShowQuestions] = useState(false);


    const onDoneTalkingAskGau = useCallback(() => {
        setShowQuestions(true);
    }, [])

    return <div style={{ position: "relative" }}>
        {askGau ? <div key="askGau">
            <GauLeft messages={askGauMessages} onDoneTalking={onDoneTalkingAskGau}>
                <div style={{
                    transform: showQuestions ? "scale(1)" : "scale(0)",
                    transition: "transform 1s",
                    paddingTop: 90,
                }}>
                    <div className="quiz-question">
                        Đây là gì?
                    </div>
                    {questions.map((question, index) => <div onClick={() => {
                        if (question.answered) {
                            return;
                        }
                        questions[index] = { ...question, answered: true };
                        setQuestions([...questions]);
                    }} className="quiz-answer" key={question.key}>
                        <Image src={question.img} style={{ maxHeight: 100, maxWidth: "90%" }} />
                        {question.answered && <>
                            Đây là {question.answers[question.answerIndex].message.toLowerCase()}
                        </>}
                    </div>)}
                </div>
            </GauLeft>
        </div> : <div key="guideGau">
            <GauQuizzes
                messages={gauMessages}
                questions={questions}
                setQuestions={setQuestions}
                originQuestions={learnQuestions}
                onDone={{
                    button: "Hỏi Gấu",
                    call: () => {
                        setAskGau(true);
                        setNextState(true);
                    }
                }}
            />
        </div>}
        {askGau && <Button onClick={() => {
            setReset(reset => reset + 1);
        }} type="primary" style={{
            position: "absolute",
            left: 0,
            top: 0
        }}>
            <ReloadOutlined />
        </Button>}
    </div>
}

export default function State4({ setNextState }) {
    const [reset, setReset] = useState(0);
    return <MainState key={reset} setNextState={setNextState} setReset={setReset} />
}